const actionTypeIdentifier = "DB90F6CE-5CA8-4624-A13D-2FE028E5191B";

export const getInventoryCircuitPlanDetails = `GET-CIRCUIT-PLAN-DETAILS-${actionTypeIdentifier}`;
export const getInventoryPlanTypesByVendorByCircuitType = `GET-CIRCUIT-PLAN-LIST-${actionTypeIdentifier}`;
export const getInventoryCircuitPlanComponents = `GET-CIRCUIT-PLAN-COMPONENTS-${actionTypeIdentifier}`;
export const deleteInventoryCircuitPlanDetails = `DELETE-CIRCUIT-PLAN-DETAILS-${actionTypeIdentifier}`;
export const addInventoryCircuitPlanDetails = `ADD-CIRCUIT-PLAN-DETAILS-${actionTypeIdentifier}`;
export const resetInventoryCircuitPlanDetails = `RESET-CIRCUIT-PLAN-DETAILS-${actionTypeIdentifier}`;

export const planDetailsFormModel = {
    PlanId: 0
};